enum EnquiryType {
  Enquiry = 'Enquiry',
  Callback = 'Callback',
  Property = 'Property',
}

export default EnquiryType;
